import axiosInstance from '../axiosInterceptor/axiosInstance'

const patchFansConfigurations = (data) => {
  const { orgId, channelId, channel } = data
  const url = `/orgs/${orgId}/channels/${channelId}`

  return axiosInstance.patch(url, channel)
}

export default patchFansConfigurations
